// extracted by mini-css-extract-plugin
export default {"container":"ProjectHelpPage2_container__maFzH","text":"ProjectHelpPage2_text__BGXzu","image":"ProjectHelpPage2_image__b3R52"};